import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow } from "vue"

const _hoisted_1 = {
  for: "file",
  class: "cursor-pointer"
}
const _hoisted_2 = {
  for: "file",
  class: "cursor-pointer d-flex justify-center align-center w-100 h-100 position-absolute"
}
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = ["accept"]
const _hoisted_6 = { class: "d-flex jusitfy-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_SelectUser = _resolveComponent("SelectUser")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_DropZone = _resolveComponent("DropZone")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_DropZoneGoogleDrive = _resolveComponent("DropZoneGoogleDrive")!
  const _component_DropZoneDropbox = _resolveComponent("DropZoneDropbox")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_file_upload = _resolveComponent("file-upload")!
  const _directive_intersect = _resolveDirective("intersect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      style: {"background-color":"transparent"},
      elevation: "0"
    }, {
      default: _withCtx(() => [
        (_ctx.documentType !== 'BANK_STATEMENT')
          ? (_openBlock(), _createBlock(_component_v_card_title, {
              key: 0,
              class: _normalizeClass(
                !_ctx.$vuetify.display.mobile
                    ? 'title font-weight-regular justify-space-between'
                    : 'title font-weight-regular pa-1'
            )
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.title), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_window, {
          modelValue: _ctx.wizardStep,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.wizardStep) = $event)),
          touchless: "",
          style: {"min-height":"27vh"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, { value: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "py-0 px-4" }, {
                  default: _withCtx(() => [
                    (_ctx.wizardStep === 2 && _ctx.companyId)
                      ? (_openBlock(), _createBlock(_component_SelectUser, {
                          key: 0,
                          companyId: _ctx.companyId,
                          modelValue: _ctx.owner,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.owner) = $event))
                        }, null, 8, ["companyId", "modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 3 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "py-0 px-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        (_ctx.documentType === 'MISCELLANEOUS')
                          ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_oss_date_picker_filled, {
                                  modelValue: _ctx.date,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event)),
                                  textFieldReadOnly: false,
                                  label: "Date du document"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                                _ctx.selectedCompany &&
                                _ctx.freeTag &&
                                !_ctx.documentId &&
                                this.workingDocumentType !== 'EXPENSE_REPORT_DOCUMENT'
                            )
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_FreeTag, {
                                  documentType: _ctx.documentType,
                                  company: _ctx.selectedCompany,
                                  companyTags: _ctx.allCompanyTags,
                                  splitUserPartitions: true,
                                  onUpdateTags: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onTags($event)))
                                }, null, 8, ["documentType", "company", "companyTags"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.drop)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 2,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("label", _hoisted_1, [
                                  _createVNode(_component_DropZone, { onFilesDropped: _ctx.onDropFile }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "d-flex align-center rounded-lg py-5 dashed"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            class: "d-flex justify-center pb-4"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, { size: "40" }, {
                                                default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                  _createTextVNode("$add")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            class: "d-flex justify-center headline"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.multiple
                                                    ? _ctx.$t("documentUpload.dropFiles")
                                                    : _ctx.$t("documentUpload.dropFile")), 1)
                                            ]),
                                            _: 1
                                          }),
                                          (
                                                ![
                                                    'BANK_STATEMENT',
                                                    'COMPANIES',
                                                    'INVOICE_PRODUCTS',
                                                    'STOCK_PRODUCTS',
                                                    'FIXED_ASSETS',
                                                    'EXPORT_OFFICE',
                                                    'ACCOUNTING_PLAN',
                                                ].includes(_ctx.documentType)
                                            )
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 0,
                                                cols: "12",
                                                class: "d-flex justify-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t("documentUpload.advice")), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            class: "d-flex justify-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.acceptedFileTypesWording), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["onFilesDropped"])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: _ctx.fileUploadColSize,
                                  class: "mb-0 pb-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      block: "",
                                      color: "ternary",
                                      variant: "tonal",
                                      class: "rounded-lg elevation-0",
                                      size: "large",
                                      "data-cy": "UploadDocuments-ManualUploadButton-OpenDialog"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("label", _hoisted_2, [
                                          _createVNode(_component_v_icon, {
                                            icon: "$attach_file",
                                            class: "mr-2"
                                          }),
                                          _cache[15] || (_cache[15] = _createTextVNode(" Cet appareil "))
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["cols"]),
                                (_ctx.localGDrive)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: _ctx.localDBox ? 4 : 6,
                                      class: "mb-0 pb-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DropZoneGoogleDrive, {
                                          clientId: '622820122137-f84p9l7u89ie8qk6ib1qa3ef7cga12nr.apps.googleusercontent.com',
                                          developerKey: 'AIzaSyCixCzLyhvavUjPS6EBocE4iYOXvm8dmMk',
                                          scope: ['https://www.googleapis.com/auth/drive.readonly'],
                                          onChange: _ctx.onGoogleDriveFilesSelected,
                                          onAuthenticated: _ctx.onAuthenticated,
                                          multiselect: _ctx.multiple,
                                          navHidden: false,
                                          authImmediate: false,
                                          upload: false,
                                          mimeTypes: _ctx.mimeTypes,
                                          viewId: 'FOLDERS'
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              block: "",
                                              color: "ternary",
                                              variant: "tonal",
                                              class: "rounded-lg mb-4 elevation-0 cursor-pointer",
                                              size: "large"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_3, [
                                                  _createVNode(_component_v_icon, {
                                                    icon: "$add_to_drive",
                                                    class: "mr-2"
                                                  }),
                                                  _cache[16] || (_cache[16] = _createTextVNode(" Google Drive "))
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["onChange", "onAuthenticated", "multiselect", "mimeTypes"])
                                      ]),
                                      _: 1
                                    }, 8, ["cols"]))
                                  : _createCommentVNode("", true),
                                (_ctx.localDBox)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 1,
                                      cols: _ctx.localGDrive ? 4 : 6,
                                      class: "mb-0 pb-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DropZoneDropbox, {
                                          apiKey: "av39x7u4hm16p67",
                                          multiselect: true,
                                          onPicked: _ctx.onDropBoxFilesSelected
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              block: "",
                                              color: "ternary",
                                              variant: "tonal",
                                              class: "rounded-lg mb-4 elevation-0 cursor-pointer",
                                              size: "large"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_4, [
                                                  _createVNode(_component_v_icon, {
                                                    icon: "$fa-dropbox",
                                                    class: "mr-2"
                                                  }),
                                                  _cache[17] || (_cache[17] = _createTextVNode(" Dropbox "))
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["onPicked"])
                                      ]),
                                      _: 1
                                    }, 8, ["cols"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.test)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 3,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field_filled, {
                                  outlined: "",
                                  label: "Fichier test",
                                  modelValue: _ctx.testFileName,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.testFileName) = $event)),
                                  "data-cy": "uploadDocuments-testFile",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.autoOpenFileDialog)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 4,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  ref: "ossOpenFileDialog",
                                  type: "file",
                                  accept: _ctx.accept,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onOpenFileDialogChange && _ctx.onOpenFileDialogChange(...args))),
                                  style: {"color":"#fff"}
                                }, null, 8, _hoisted_5), [
                                  [_directive_intersect, _ctx.openFileDialog]
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (_ctx.formatError)
                      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_alert, { type: "error" }, {
                                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                                    _createTextVNode("Format de fichier non supporté")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("shared.amountOfFiles", {
                                        count: _ctx.fileToUploadCount,
                                    })), 1)
                          ]),
                          _: 1
                        }),
                        (_ctx.isPossibleToMerge)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "2"
                            }, {
                              default: _withCtx(() => [
                                (!_ctx.isMergingDocument)
                                  ? (_openBlock(), _createBlock(_component_v_switch, {
                                      key: 0,
                                      modelValue: _ctx.isLinkedDocument,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isLinkedDocument) = $event)),
                                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.linkDocument()), ["stop"]))
                                    }, null, 8, ["modelValue"]))
                                  : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.isPossibleToMerge)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "7"
                            }, {
                              default: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createElementVNode("p", null, "Fusionner les images pour créer une facture multi-page", -1)
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (_ctx.files.length)
                      ? (_openBlock(), _createBlock(_component_draggable, {
                          key: 1,
                          modelValue: _ctx.files,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.files) = $event)),
                          handle: ".handle",
                          "item-key": (file, index) => index,
                          "two-line": ""
                        }, {
                          item: _withCtx(({ element: file, index: i }) => [
                            (_openBlock(), _createBlock(_component_v_list_item, {
                              class: _normalizeClass(["oss-list-item", _ctx.getFileItemClass(file)]),
                              key: i,
                              ripple: ""
                            }, {
                              prepend: _withCtx(() => [
                                (file.loading)
                                  ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                                      key: 0,
                                      type: "image",
                                      class: "my-0 mr-2",
                                      style: {"height":"40px","width":"40px","overflow":"hidden"}
                                    }))
                                  : (file.thumb)
                                    ? (_openBlock(), _createBlock(_component_v_img, {
                                        key: 1,
                                        src: file.thumb,
                                        class: "my-0 mr-2",
                                        alt: "document thumbnail",
                                        width: "50",
                                        height: "50"
                                      }, null, 8, ["src"]))
                                    : (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 2,
                                        class: "pa-2"
                                      }, {
                                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                                          _createTextVNode("$oss-file")
                                        ])),
                                        _: 1
                                      }))
                              ]),
                              append: _withCtx(() => [
                                _createVNode(_component_v_btn_icon, {
                                  icon: "$delete_outline",
                                  onClick: ($event: any) => (_ctx.onFileRemove(file))
                                }, null, 8, ["onClick"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        (
                                                [
                                                    'MISCELLANEOUS',
                                                    'BANK_STATEMENT',
                                                    'COMPANIES',
                                                    'INVOICE_PRODUCTS',
                                                    'STOCK_PRODUCTS',
                                                    'FIXED_ASSETS',
                                                ].includes(_ctx.documentType) && file.status === 'ok'
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              cols: "12",
                                              class: "pt-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: file.displayName,
                                                  "onUpdate:modelValue": ($event: any) => ((file.displayName) = $event),
                                                  outlined: "",
                                                  label: "Nom du fichier",
                                                  "hide-details": "",
                                                  density: "compact"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : (_openBlock(), _createBlock(_component_v_col, {
                                              key: 1,
                                              cols: "12"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(file.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (file.active || file.progress !== '0.00')
                                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                          key: 0,
                                          color: "secondary",
                                          height: "10",
                                          rounded: "",
                                          "model-value": file.progress
                                        }, null, 8, ["model-value"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024),
                                (file.status !== 'ok' && file.status !== '')
                                  ? (_openBlock(), _createBlock(_component_v_list_item_title, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { class: "mr-2" }, {
                                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                                            _createTextVNode("$warning")
                                          ])),
                                          _: 1
                                        }),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("documentUpload." + file.status)), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createVNode(_component_v_list_item_subtitle, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(file.type), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_list_item_subtitle, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(file.size), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ], 64))
                              ]),
                              _: 2
                            }, 1032, ["class"]))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "item-key"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_ctx.showActionsBtn)
          ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 1 }, {
              default: _withCtx(() => [
                (_ctx.showPrevious)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      rounded: "",
                      elevation: "0",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.previousStep())),
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                        _createTextVNode(" Précédent ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_spacer),
                (_ctx.nextStepBtn)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      rounded: "",
                      style: {"color":"#fff"},
                      class: "btn mr-0",
                      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.nextStepBtnAction()), ["prevent"])),
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode(" Suivant ")
                      ])),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_ctx.wizardStep >= 1 && _ctx.wizardStep <= 2)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            rounded: "",
                            style: {"color":"#fff"},
                            class: "btn mr-0",
                            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.nextStep()), ["prevent"])),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[24] || (_cache[24] = [
                              _createTextVNode(" Suivant ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.wizardStep === 3)
                        ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            size: "small",
                            rounded: "",
                            elevation: "0",
                            style: {"color":"#fff"},
                            class: "mr-0",
                            onClick: _withModifiers(_ctx.startUpload, ["prevent"]),
                            disabled: !_ctx.fileToUploadCount
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.startUpload")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick", "disabled"])), [
                            [_vShow, !_ctx.uploader || !_ctx.uploader.active]
                          ])
                        : _createCommentVNode("", true),
                      (_ctx.wizardStep === 3)
                        ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            key: 2,
                            rounded: "",
                            color: "red",
                            style: {"color":"#fff"},
                            class: "btn mr-0",
                            elevation: "0",
                            loading: "",
                            onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.uploader.active = false), ["prevent"])),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode(" Import en cours ")
                            ])),
                            _: 1
                          }, 512)), [
                            [_vShow, _ctx.uploader && _ctx.uploader.active]
                          ])
                        : _createCommentVNode("", true)
                    ], 64))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_file_upload, {
      ref: "uploader",
      modelValue: _ctx.files,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.files) = $event)),
      headers: _ctx.actionHeaders,
      extensions: _ctx.extensions,
      accept: _ctx.accept,
      drop: _ctx.drop,
      multiple: _ctx.multiple,
      label: 'Sélectionnez un tag pour tout les documents',
      "drop-directory": true,
      onInputFilter: _ctx.inputFilter,
      onInputFile: _ctx.inputFile,
      "custom-action": _ctx.customAction
    }, null, 8, ["modelValue", "headers", "extensions", "accept", "drop", "multiple", "onInputFilter", "onInputFile", "custom-action"])
  ], 64))
}